import { createFileRoute } from '@tanstack/react-router'
import { requireAnyPermission } from '../../../../../app/guards'
import { StatementPrintPage } from '../../../../../features/projects/contracting/statement-print-page'

/** The contract's final account statement, EN/AR (projects/04 §15.3). */
export const Route = createFileRoute('/_app/projects/$projectId/contract/statement')({
  staticData: { crumb: 'projectStatementPrint' },
  beforeLoad: ({ context }) =>
    requireAnyPermission(context.session, 'projects.contract', 'projects.financials'),
  component: StatementPrintPage,
})
